
import { useState, useEffect } from 'react';

const useCountdown = (initialTime: string) => {

  const [time, setTime] = useState<string>(initialTime);

  useEffect(() => {
    if (initialTime.includes(":")) {
      const [hours, minutes, seconds] = initialTime.split(':').map(Number);
      let totalSeconds = hours * 3600 + minutes * 60 + seconds;
      if (totalSeconds > 0) {
        const intervalId = setInterval(() => {
          if (totalSeconds > 0) {
            totalSeconds -= 1;
            const h = Math.floor(totalSeconds / 3600);
            const m = Math.floor((totalSeconds % 3600) / 60);
            const s = totalSeconds % 60;
            setTime(`${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`);
          } else {
            clearInterval(intervalId);
            setTime("")
          }
        }, 1000);
        return () => clearInterval(intervalId);
      }
      else {
        setTime("")
      }
    } else {
      setTime(initialTime)
    }
  }, [initialTime]);

  return time;
};

export default useCountdown;